import { z } from "zod";
/**
 * Voice persona config (§6.8 sensory config, §12.6).
 * Default is a warm woman's voice — NOT Zoidberg-the-character. The 6 AM voice
 * can be gentler than the Hard Wake voice, so energy is selectable per moment.
 */
export const GreetingEnergy = z.enum(["gentle", "neutral", "firm"]);
export const Persona = z.object({
    /** ElevenLabs voice id, resolved during build by auditioning candidates. */
    voiceId: z.string().min(1),
    /** Human-readable label for the PWA, e.g. "Warm — Aria". */
    label: z.string().default("default"),
    /** Playback rate multiplier; 1.0 = natural conversational speed. */
    speed: z.number().min(0.7).max(1.3).default(1.0),
    /** Energy for the first contact of the morning. */
    greetingEnergy: GreetingEnergy.default("gentle"),
    /** Energy once the ladder reaches Hard Wake. */
    hardWakeEnergy: GreetingEnergy.default("firm"),
});
//# sourceMappingURL=persona.js.map